import {
  toRwaQuote,
  useInxTickerQuery,
} from '@r-client/republic/data/offerings';
import {
  REAL_WORLD_ASSETS,
  RealWorldAssetsRail,
} from '@r-client/republic/ui/offerings';
import { ASSET_TYPES } from '@r-client/shared/data/analytics';

import { useInvestmentOpportunitiesAnalytics } from '../../hooks/use-investment-opportunities-analytics';

/**
 * The real-world assets rail as it appears on /investment-opportunities: the
 * presentation lives in `RealWorldAssetsRail`, and this supplies the data and
 * this page's analytics.
 *
 * `isLcpCandidate` is left at its default — on this page the first card's hero is
 * the largest thing above the fold, so it is the one worth preloading.
 */
export const RealWorldAssets = () => {
  const { assetCardClicked, seeAllClicked } =
    useInvestmentOpportunitiesAnalytics();
  // Same query key as the crypto rail, so react-query serves both sections from
  // one fetch. `isLoading` and `isError` go unused deliberately: each card
  // falls back to its fixture price until live data arrives, so this section
  // has no loading or error state to render.
  const { tickerData } = useInxTickerQuery();

  const assets = REAL_WORLD_ASSETS.map((asset) => ({
    ...asset,
    ...toRwaQuote(tickerData, asset.symbol),
  }));

  return (
    <RealWorldAssetsRail
      assets={assets}
      seeAllHref="https://trading.republic.com/trade"
      isExternal={true}
      onAssetClick={(id) => assetCardClicked(ASSET_TYPES.RWA, id)}
      onSeeAllClick={() => seeAllClicked(ASSET_TYPES.RWA)}
    />
  );
};
